<script>
import Constants from '../constants';

export default {
  name: 'shareBtn',
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data() {
    return {
      ready: false,
      url: '',
      twitterUrl: '',
      lineUrl: '',
      faceBookUrl: '',
      threadsUrl: '',
      blueskyUrl: '',

      showCopyMes: false,
      copyMes: '',
    };
  },
  created() {
    const title = document.title;
    this.url = document.location.href;
    this.twitterUrl = `https://twitter.com/intent/tweet?text=${title}&url=${this.url}&related=${Constants.SNS.TWITTER_ID}`;
    this.lineUrl = `https://line.me/R/share?text=${title} ${this.url}`;
    this.faceBookUrl = `http://www.facebook.com/share.php?u=${this.url}`;
    this.threadsUrl = `https://www.threads.net/intent/post?text=${title} ${this.url}`;
    this.blueskyUrl = `https://bsky.app/intent/compose?text=${title} ${this.url}`;

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    onCopy () {
      this.copyMes = this.$t('message.snsName.copySuccess');
      this.showCopyMes = true;
      setTimeout(()=> {
        this.showCopyMes = false;
      }, 1000);
    },
    onError () {
      this.copyMes = this.$t('message.snsName.copyError');
      this.showCopyMes = true;
      setTimeout(()=> {
        this.showCopyMes = false;
      }, 1000);
    },
  },
};
</script>

<template>
  <div class="share-btns" v-if="ready" :class="[isFixed ? 'isFixed' : '', $mq]">
    <a class="btn share-twitter-btn"
      :href="twitterUrl"
      target="_blank"
      :title="$t('message.snsName.share', {sns: $t('message.snsName.twitter')})"
      rel="nofollow"
    ></a>
    <a class="btn share-line-btn"
      :href="lineUrl"
      target="_blank"
      :title="$t('message.snsName.share', {sns: $t('message.snsName.line')})"
      rel="nofollow"
    ></a>
    <a class="btn share-faceBook-btn"
      :href="faceBookUrl"
      target="_blank"
      :title="$t('message.snsName.share', {sns: $t('message.snsName.faceBook')})"
      rel="nofollow"
    ></a>
    <a class="btn share-bluesky-btn"
      :href="blueskyUrl"
      target="_blank"
      :title="$t('message.snsName.share', {sns: $t('message.snsName.bluesky')})"
      rel="nofollow"
    ></a>
    <a class="btn share-threads-btn"
      :href="threadsUrl"
      target="_blank"
      :title="$t('message.snsName.share', {sns: $t('message.snsName.threads')})"
      rel="nofollow"
    ></a>
    <a class="btn share-copy-btn"
      :title="$t('message.snsName.copy')"
      v-clipboard:copy="url"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    ></a>
    <div class="copy-mes" v-if="showCopyMes">{{copyMes}}</div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .share-btns {
    height: 45px;
    display: flex;
    padding: 0 5px 5px 5px;
    position: relative;
    .btn {
      display: block;
      cursor: pointer;
      width: 30px;
      height: 30px;
      margin-left: 0;
      @include bgCenter;
      transition: 0.1s ease-out;
      &:hover {
        transform: scale(1.2);
      }
      &.share-twitter-btn {background-image: url(../assets/img/sns/shareTwitter.svg); }
      &.share-line-btn {background-image: url(../assets/img/sns/shareLine.svg); }
      &.share-faceBook-btn {background-image: url(../assets/img/sns/shareFacebook.svg); }
      &.share-bluesky-btn {background-image: url(../assets/img/sns/shareBluesky.svg); }
      &.share-threads-btn {background-image: url(../assets/img/sns/shareThreads.svg); }
      &.share-copy-btn {background-image: url(../assets/img/sns/shareCopy.svg); }
    }
    .copy-mes {
      @include absolute100;
      bottom: 5px;
      text-align: center;
      line-height: 40px;
      border-radius: 10px;
      background: $bgColorA50;
      color: $textColor;
    }
    &.isFixed {
      position: fixed;
      bottom: 0;
      left: 0;
      max-width: 100%;
      z-index: $zIndexFixedShareBtn;
    }

    // responsible -----------------------------------------------
    &.viewLg {
      justify-content: center;
      .btn { margin: 5px;}
      &.isFixed {
        bottom: 30px;
        left: 30px;
      }
    }
    &.viewMd {
      justify-content: center;
      .btn { margin: 5px;}
    }
    &.viewSm {
      justify-content: space-around;
      &.isFixed {
        width: 100%;
      }
    }
  }
</style>
